import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocCategoryIsDnAndDocTypeAllowedRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentCategory = control.get('documentCategory')!.value;
	const documentType = control.get('documentType')!.value;
	const policyHolderId = control.get('policyHolderId')!.value;
	const documentTypeArray = ['EGD022', 'EGD033'];

	return !policyHolderId && !!documentType && documentCategory ===  "EGD03"
	            && !documentTypeArray.includes(documentType) ? { checkDocCategoryIsDnAndDocTypeAllowedFlag: true } : null;
};
